import { setSidebarVisibleAction } from 'editor/src/store/editorModules/sidebar/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

const hideSidebarOperation = () => (dispatch: ThunkDispatch) => {
  dispatch(setSidebarVisibleAction(false));
};

export default hideSidebarOperation;
